namespace TabAurous.Finance {
    export namespace AccountPayableService {
        export const baseUrl = 'Finance/AccountPayable';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PartyBalanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Finance/AccountPayable/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>AccountPayableService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
